import ExcelJS from 'exceljs'
import * as FileSaver from 'file-saver'

export async function downloadLink(filaDadosTicket, filaDadosForms) {
  try {
    if (Object.keys(filaDadosTicket).length === 0 && Object.keys(filaDadosForms).length === 0) {
      this.$toast.warning('Sem dados para gerar relatório!')
      return
    }

    const workbook = new ExcelJS.Workbook()
    const sheetDados = workbook.addWorksheet('Dados ticket')

    sheetDados.columns = [
      { header: 'Fila', key: 'fila', width: 20 },
      { header: 'Agente', key: 'agente', width: 10 },
      { header: 'Protocolo', key: 'protocolo', width: 20 },
      { header: 'Data Abertura', key: 'dataAbertura', width: 15 },
      { header: 'Horario Abertura', key: 'horaAbertura', width: 15 },
      { header: 'Data Fechamento', key: 'dataFechamento', width: 15 },
      { header: 'Horario Fechamento', key: 'horaFechamento', width: 15 },
      { header: 'Tipo de Solicitacao', key: 'tipoSolicitacao', width: 15 },
      { header: 'Status', key: 'nomeStatus', width: 15 },
      { header: 'Canal', key: 'canal', width: 15 },
      { header: 'Tempo Total de Atendimento', key: 'tempoTotalAtendimento', width: 15 },
      { header: 'Tempo de Primeira Resposta', key: 'tempoDePrimeiraResposta', width: 15 },
      { header: 'Tempo Médio entre Resposta', key: 'tempoMedioEntreRespostas', width: 15 },
      { header: 'Quantidade de Mensagens', key: 'quantidadeMensagens', width: 15 },
      { header: 'Quantidade de Mensagens do Atendente', key: 'quantidadeMensagensAtendente', width: 15 },
      { header: 'Quantidade de Mensagens do Cliente', key: 'quantidadeMensagensCliente', width: 15 },
      { header: 'Nome Cliente', key: 'nomeCliente', width: 15 },
      { header: 'E-mail', key: 'emailCliente', width: 30 },
      { header: 'Celular', key: 'celularCliente', width: 15 },
      { header: 'CPF', key: 'cpfCliente', width: 15 },
      { header: 'RG', key: 'rgCliente', width: 15 },
      { header: 'Orgao Emissor', key: 'orgaoEmissor', width: 15 },
      { header: 'Data Nascimento', key: 'dataNascimento', width: 15 },
      { header: 'CEP', key: 'cep', width: 15 },
      { header: 'Estado', key: 'estado', width: 15 },
      { header: 'Cidade', key: 'cidade', width: 15 },
      { header: 'Bairro', key: 'bairro', width: 15 },
      { header: 'Rua', key: 'rua', width: 15 },
      { header: 'Numero', key: 'numero', width: 15 },
      { header: 'Complemento', key: 'complemento', width: 15 },
    ]

    filaDadosTicket.forEach(item => {
      const dataAbertura = new Date(item.dataAbertura)
      const dataFechamento = new Date(item.dataFechamento)
      const dataNascimento = new Date(item.dataNascimento)
      sheetDados.addRow({
        fila: item.fila,
        agente: item.agente,
        protocolo: item.protocolo,
        dataAbertura: dataAbertura ? dataAbertura.toLocaleDateString('pt-BR') : '',
        horaAbertura: item.horaAbertura,
        dataFechamento: item.dataFechamento
          ? new Date(item.dataFechamento).toLocaleDateString('pt-BR')
          : '', // Formatação para dia/mês/ano
        horaFechamento: item.horaFechamento,
        tipoSolicitacao: item.tipoSolicitacao,
        nomeStatus: item.nomeStatus,
        canal: item.canal,
        tempoTotalAtendimento: item.tempoTotalAtendimento,
        tempoDePrimeiraResposta: item.tempoDePrimeiraResposta,
        tempoMedioEntreRespostas: item.tempoMedioEntreRespostas,
        quantidadeMensagens: item.quantidadeMensagens,
        quantidadeMensagensAtendente: item.quantidadeMensagensAtendente,
        quantidadeMensagensCliente: item.quantidadeMensagensCliente,
        nomeCliente: item.nomeCliente,
        emailCliente: item.emailCliente,
        celularCliente: item.celularCliente,
        cpfCliente: item.cpfCliente,
        rgCliente: item.rgCliente,
        orgaoEmissor: item.orgaoEmissor,
        dataNascimento: dataNascimento ? dataNascimento.toLocaleDateString('pt-BR') : '',
        cep: item.cep,
        estado: item.estado,
        cidade: item.cidade,
        bairro: item.bairro,
        rua: item.rua,
        numero: item.numero,
        complemento: item.complemento,
      })
    })

    const columnsForms = [
      { header: 'Formulario', key: 'nomeFormulario', width: 20 },
      { header: 'Nome Integrante', key: 'nomeIntegrante', width: 20 },
      { header: 'Protocolo', key: 'protocolo', width: 20 },
      { header: 'Componente', key: 'componente', width: 15 },
      { header: 'Opção Componente', key: 'componenteOpcao', width: 25 },
      { header: 'Texto Componente', key: 'componenteTexto', width: 25 },
      { header: 'Link', key: 'link', width: 25 },
    ]

    filaDadosForms.forEach(item => {
      const sheetForms = workbook.addWorksheet(item.nomeFormulario)

      sheetForms.columns = columnsForms

      const respostasForms = item.respostas

      respostasForms.forEach(res => {
        sheetForms.addRow({
          nomeFormulario: res.nomeFormulario,
          nomeIntegrante: res.nomeIntegrante,
          protocolo: res.protocolo,
          componente: res.componente,
          componenteOpcao: res.componenteOpcao,
          componenteTexto: res.componenteTexto,
          link: res.link,
        })
      })
    })

    const buffer = await workbook.xlsx.writeBuffer()

    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    FileSaver.saveAs(blob, 'Relatorio_fila.xlsx')
  } catch (error) {
    console.error('Erro durante a geração ou download do relatório:', error)
  }
}
